import { dev } from '$app/environment';
import { base } from '$app/paths';
import { SW_MESSAGE_REQUEST_SESSION, SW_MESSAGE_SET_SESSION } from '$lib/constants';
import { SessionService } from './session.service';

export class ServiceWorkerService {
	/**
	 * Registers the media-auth service worker and keeps it supplied with the current session.
	 * The worker asks for the session with a `requestSession` message when a media request
	 * arrives before it has one.
	 */
	static register(): void {
		if (!('serviceWorker' in navigator)) return;

		const sendSession = () => {
			const session = SessionService.getFallback();
			ServiceWorkerService.pushSession(session?.baseUrl, session?.accessToken);
		};

		navigator.serviceWorker
			.register(`${base}/service-worker.js`, { type: dev ? 'module' : 'classic' })
			.then(sendSession);
		navigator.serviceWorker.ready.then(sendSession);

		navigator.serviceWorker.addEventListener('message', (ev: MessageEvent) => {
			if (ev.data?.type === SW_MESSAGE_REQUEST_SESSION) sendSession();
		});
	}

	/**
	 * Sends the session to the controlling worker; omitting both arguments clears it (logout).
	 * @param baseUrl - homeserver base URL
	 * @param accessToken - Matrix access token
	 */
	static pushSession(baseUrl?: string, accessToken?: string): void {
		if (!('serviceWorker' in navigator)) return;
		if (!navigator.serviceWorker.controller) return;

		navigator.serviceWorker.controller.postMessage({
			type: SW_MESSAGE_SET_SESSION,
			accessToken,
			baseUrl
		});
	}
}
